import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import RulesPopover from '../../page/portal/user/RulesPopover';
import { Stack } from '@mui/material';

export default function ColumnFormDialog(props) {
    const { open, setOpen, column, action } = props;

    const [nome, setNome] = React.useState('');
    const [rule, setRule] = React.useState('');
    
    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(()=>{
        if( open){
            console.log(column)
            setNome(column.nome);
        }
    },[open])

    const handleSubmit = (event) => {
        event.preventDefault();
        if( action) action({
                nome: nome,
                regra: rule
            });
        handleClose();
    };

    function handleRuleAction(regra){
        console.log( regra );
        setRule(regra.nome);
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
            <DialogTitle >Edição coluna</DialogTitle>
            <DialogContent sx={{ paddingBottom: 0 }}>
                <DialogContentText>
                    Informe os dados da coluna
                </DialogContentText>
                <form onSubmit={handleSubmit}>
                    <Stack direction="row" spacing={2}>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        value={nome} onChange={(e)=> setNome(e.target.value)}
                        label="Nome"                        
                        // fullWidth
                        width='600px'
                        variant="filled"
                    />

                    <RulesPopover showTxt={true} action={handleRuleAction} regra={rule} />
                    </Stack>

                    <DialogActions>
                        <Button onClick={handleClose}>Fechar</Button>
                        <Button type="submit">Salvar</Button>
                    </DialogActions>
                </form>
            </DialogContent>
            
        </Dialog>
    );
}
